export default __webpack_public_path__ + "static/media/rgs_mobile_small.f989d649.jpg";